import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { LanguageSwitcher } from '@core/components/LanguageSwitcher';
import { LoadingSpinner } from '@core/components/LoadingSpinner';
import { ThemeButton } from '@core/components/navigation/ThemeButton';

/**
 * GeneralLayout provides a basic page structure for non-authenticated sections of the app.
 *
 * Use this layout for:
 * - Authentication pages (login, register, password reset)
 * - Error pages (404, connection error)
 * - Public landing pages
 */
export default function GeneralLayout() {
  return (
    <Suspense
      fallback={
        <div className="flex h-screen w-full items-center justify-center">
          <LoadingSpinner />
        </div>
      }
    >
      <main className="flex min-h-screen w-full items-center justify-center">
        <ThemeButton className="fixed top-4 right-4 z-10 lg:top-auto lg:right-auto lg:bottom-18 lg:left-1/2 lg:-translate-x-1/2" />

        <LanguageSwitcher className="fixed top-4 right-4 z-10 w-40" />

        <Outlet />
      </main>
    </Suspense>
  );
}
